/**
 * Yield Layer Helpers
 *
 * Utilities for creating Mapbox GL JS expressions for yield H3 hexagon vector tiles.
 * Follows the same pattern as noiseLayerHelpers.ts.
 */

import type { DynamicLayerConfig } from '../config/dynamicLayersConfig'

export const YIELD_LAYER_ID = 'yield-hexagon'

export const YIELD_RANGES = [2.0, 2.3, 2.7, 3.1, 3.5, 4.0, 4.3, 5.3]

export const YIELD_COLORS = [
  '#d7191c',
  '#f17c4a',
  '#fec980',
  '#ffffbf',
  '#d9ef8b',
  '#a6d96a',
  '#66bd63',
  '#1a9641',
]

export function isYieldLayer(layerId: string): boolean {
  return layerId === YIELD_LAYER_ID
}

export function getYieldField(): string {
  return 'avg_yield.value'
}

export function createYieldFillColorExpression(
  layerConfig: DynamicLayerConfig
): any {
  const colors = layerConfig.render?.colors || YIELD_COLORS
  const field = getYieldField()

  const stops: any[] = []
  for (let i = 0; i < Math.min(YIELD_RANGES.length, colors.length); i++) {
    stops.push(YIELD_RANGES[i], colors[i])
  }

  return ['interpolate', ['linear'], ['get', field], ...stops]
}

export function formatYieldValue(value: number | string | undefined): string {
  if (value === undefined || value === null) {
    return 'No data'
  }

  const numValue = typeof value === 'string' ? parseFloat(value) : value

  if (isNaN(numValue)) {
    return 'No data'
  }

  return `${numValue.toFixed(1)}%`
}

export function getYieldVectorTileUrl(apiBaseUrl: string): string {
  return `${apiBaseUrl}/buildings/yield-tiles/{z}/{x}/{y}`
}

export function createYieldVectorTileSource(apiBaseUrl: string) {
  return {
    type: 'vector' as const,
    tiles: [getYieldVectorTileUrl(apiBaseUrl)],
    minzoom: 10,
    maxzoom: 16,
  }
}
